/**
 * UiMixin
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc UI Mixin with helpers and tools for the UI behavior and deployment of the components
 * @since 2021-02-03
**/

import easyScroll from 'easy-scroll';
import VueScrollTo from 'vue-scrollto';

export var UiMixin = {
  methods: {
    // Scrolls to given DOM element #id using the brower scroll to API
    scrollTo (element, within, duration, offset) {
      element = element instanceof Element ? element : document.getElementById(element); // Pass the DOM object or the #ID
      duration = duration || 400;
      offset = offset || 0;

      // For when the scroll is intended to work within a specific dom object other than document or window
      if (within) {
        easyScroll({
          scrollableDomEle: within,
          direction: 'bottom',
          duration: duration || 200,
          easingPreset: 'easeInOutCubic',
          scrollAmount: element.offsetTop - 15 - offset
        });

        return;
      }

      // Default behavior using the native funciton for scrolling the document
      // element.scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start'
      // });

      // window.scrollTo({
      //   behavior: 'smooth',
      //   top: element.getBoundingClientRect().top + window.scrollY - offset
      // });
      VueScrollTo.scrollTo(element, duration, {
        offset: offset
      });
    },

    // Scrolling within Composer content area
    scrollToComposerSection(elementId, offset) {
      const scrollableArea = document.querySelector('#composer .module .module__content');

      this.$nextTick(() => {
        this.scrollTo(elementId, scrollableArea, 400, (offset || scrollableArea.scrollTop));
      });
    },

    // Checks if given element is visible (even partially) in the viewport
    isInScrollView (element) {
      element = element instanceof Element ? element : document.getElementById(element); // Pass the DOM object or the #ID

      if (element === null || element === undefined) {
        return true;
      }

      const bounding = element.getBoundingClientRect();
      const elementHeight = element.offsetHeight;
      const elementWidth = element.offsetWidth;

      return (
        bounding.top >= -elementHeight &&
        bounding.left >= -elementWidth &&
        bounding.right <= (window.innerWidth ||
        document.documentElement.clientWidth) + elementWidth &&
        bounding.bottom <= (window.innerHeight ||
        document.documentElement.clientHeight) + elementHeight
      );
    }
  }
};
